<div
  class="checkout-stock-item-summary"
  *ngIf="pageId !== cartPageId && inStockItems.length > 0 && backOrderItems.length > 0"
>
  <h3
    class="checkout-stock-item-summary-title"
    [innerHTML]="'cart.checkoutDetailsInstock.title' | cxTranslate : { item: inStockItems.length }"
  ></h3>
  <span class="checkout-stock-item-summary-desc">{{ 'cart.checkoutDetailsInstock.desc' | cxTranslate }}</span>
</div>
<ng-container *ngFor="let item of inStockItems; let i = index; let last = last">
  <div class="item-list-row">
    <div
      class="item-list-items"
      *ngIf="getControl(item) | async as control"
      [class.is-changed]="control.get('quantity').dirty || control.get('memo').dirty"
    >
      <cx-cart-item
        [item]="item"
        [cartPageId]="cartPageId"
        [quantityControl]="control.get('quantity')"
        [memoControl]="control.get('memo')"
        [readonly]="false"
        [potentialProductPromotions]="getPotentialProductPromotionsForItem(item)"
        [promotionLocation]="promotionLocation"
        [options]="options"
        [pageId]="pageId"
        [lastItem]="last"
        [noStockError]="getCartError(item, 'noStock')"
        [lowStockError]="getCartError(item, 'lowStock')"
        [unapprovedError]="unapprovedError"
        [dealerSpinner]="dealerSpinner"
        [removeSpinner]="removeSpinner"
        [dateFormatted]="dateFormatted"
        [skipVariantCategory]="skipVariantCategory"
        [appliedPromotions]="appliedPromotions"
        [showWarehouseFeature]="showWarehouseFeature"
      >
      </cx-cart-item>
    </div>
  </div>
</ng-container>

<!-- DISCONTINUED ITEMS - CART PAGE ONLY-->
<ng-container *ngFor="let item of discontinuedItems; let i = index; let last = last">
  <div class="item-list-row">
    <div
      class="item-list-items"
      *ngIf="getControl(item) | async as control"
      [class.is-changed]="control.get('quantity').dirty || control.get('memo').dirty"
    >
      <cx-cart-item
        [item]="item"
        [cartPageId]="cartPageId"
        [quantityControl]="control.get('quantity')"
        [memoControl]="control.get('memo')"
        [readonly]="false"
        [potentialProductPromotions]="getPotentialProductPromotionsForItem(item)"
        [promotionLocation]="promotionLocation"
        [options]="options"
        [pageId]="pageId"
        [lastItem]="last"
        [noStockError]="getCartError(item, 'noStock')"
        [lowStockError]="getCartError(item, 'lowStock')"
        [unapprovedError]="unapprovedError"
        [dealerSpinner]="dealerSpinner"
        [removeSpinner]="removeSpinner"
        [dateFormatted]="dateFormatted"
        [skipVariantCategory]="skipVariantCategory"
        [appliedPromotions]="appliedPromotions"
        [showWarehouseFeature]="showWarehouseFeature"
      >
      </cx-cart-item>
    </div>
  </div>
</ng-container>

<div
  class="checkout-stock-item-summary backorder-summary"
  *ngIf="pageId !== cartPageId && inStockItems.length >= 0 && backOrderItems.length > 0"
>
  <h3
    class="checkout-stock-item-summary-title"
    [innerHTML]="'cart.checkoutDetailsBackorder.title' | cxTranslate : { item: backOrderItems.length }"
  ></h3>
  <span class="checkout-stock-item-summary-desc">{{ 'cart.checkoutDetailsBackorder.desc' | cxTranslate }}</span>
</div>
<ng-container *ngFor="let item of backOrderItems; let i = index; let last = last">
  <div class="item-list-row">
    <div
      class="item-list-items"
      *ngIf="getControl(item) | async as control"
      [class.is-changed]="control.get('quantity').dirty || control.get('memo').dirty"
    >
      <cx-cart-item
        [item]="item"
        [cartPageId]="cartPageId"
        [quantityControl]="control.get('quantity')"
        [memoControl]="control.get('memo')"
        [readonly]="false"
        [potentialProductPromotions]="getPotentialProductPromotionsForItem(item)"
        [promotionLocation]="promotionLocation"
        [options]="options"
        [pageId]="pageId"
        [lastItem]="last"
        [noStockError]="getCartError(item, 'noStock')"
        [lowStockError]="getCartError(item, 'lowStock')"
        [unapprovedError]="unapprovedError"
        [dateFormatted]="dateFormatted"
        [skipVariantCategory]="skipVariantCategory"
        [appliedPromotions]="appliedPromotions"
        [showWarehouseFeature]="showWarehouseFeature"
      >
      </cx-cart-item>
    </div>
  </div>
</ng-container>

<!-- FREE GIFTS - CART PAGE ONLY-->
<ng-container *ngFor="let item of freeGifts; let i = index; let last = last">
  <div class="item-list-row">
    <div
      class="item-list-items"
      *ngIf="getControl(item) | async as control"
      [class.is-changed]="control.get('quantity').dirty || control.get('memo').dirty"
    >
      <cx-cart-item
        [item]="item"
        [cartPageId]="cartPageId"
        [quantityControl]="control.get('quantity')"
        [memoControl]="control.get('memo')"
        [readonly]="false"
        [potentialProductPromotions]="getPotentialProductPromotionsForItem(item)"
        [promotionLocation]="promotionLocation"
        [options]="options"
        [pageId]="pageId"
        [lastItem]="last"
        [noStockError]="getCartError(item, 'noStock')"
        [lowStockError]="getCartError(item, 'lowStock')"
        [unapprovedError]="unapprovedError"
        [dateFormatted]="dateFormatted"
        [appliedPromotions]="appliedPromotions"
        [showWarehouseFeature]="showWarehouseFeature"
      >
      </cx-cart-item>
    </div>
  </div>
</ng-container>

<!-- OUT OF STOCK ITEMS - CART PAGE ONLY-->
<ng-container *ngFor="let item of outStockItems; let i = index; let last = last">
  <div class="item-list-row">
    <div
      class="item-list-items"
      *ngIf="getControl(item) | async as control"
      [class.is-changed]="control.get('quantity').dirty"
    >
      <cx-cart-item
        [item]="item"
        [cartPageId]="cartPageId"
        [quantityControl]="control.get('quantity')"
        [readonly]="false"
        [potentialProductPromotions]="getPotentialProductPromotionsForItem(item)"
        [promotionLocation]="promotionLocation"
        [options]="options"
        [pageId]="pageId"
        [lastItem]="last"
        [noStockError]="getCartError(item, 'noStock')"
        [lowStockError]="getCartError(item, 'lowStock')"
        [unapprovedError]="unapprovedError"
        [dateFormatted]="dateFormatted"
        [appliedPromotions]="appliedPromotions"
        [showWarehouseFeature]="showWarehouseFeature"
      >
      </cx-cart-item>
    </div>
  </div>
</ng-container>
